export default __webpack_public_path__ + "static/media/0x3fb256cfefedb6a54de7465c0ee86dc574ae464d.402c3e35.webp";